import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import Daggamalt from 'assets/images/rules/daggamalt.jpg';
import SweetPressedHaste from 'assets/images/rules/sweetpressedhaste.jpg';
import Moonspill from 'assets/images/rules/moonspill.jpg';
import PurifiedDaggamalt from 'assets/images/rules/purifieddaggamalt.jpg';
import PurifiedSweetPressedHaste from 'assets/images/rules/purifiedsweetpressedhaste.jpg';
import PurifiedMoonspill from 'assets/images/rules/purifiedmoonspill.jpg';
import LegofFena from 'assets/images/rules/legoffena.jpg';
import CynosuralOil from 'assets/images/rules/cynosuraloil.jpg';
import RedDeviledDates from 'assets/images/rules/reddevileddates.jpg';

//Guardian
import GuardianShoulder from 'assets/images/rules/guardian/armguards_of_the_defiant.jpg';
import GuardianBelt from 'assets/images/rules/guardian/belt_of_the_defiant.jpg';
import GuardianBoots from 'assets/images/rules/guardian/boots_of_the_defiant.jpg';
import GuardianChest from 'assets/images/rules/guardian/chestguard_of_the_defiant.jpg';
import GuardianGloves from 'assets/images/rules/guardian/gauntlets_of_the_defiant.jpg';
import GuardianHelm from 'assets/images/rules/guardian/helm_of_the_defiant.jpg';
import GuardianLegs from 'assets/images/rules/guardian/legguards_of_the_defiant.jpg';
import GuardianWrists from 'assets/images/rules/guardian/vambraces_of_the_defiant.jpg';

import ConquerorShoulder from 'assets/images/rules/conqueror/armguards_of_the_vanguard.jpg';
import ConquerorBelt from 'assets/images/rules/conqueror/belt_of_the_vanguard.jpg';
import ConquerorBoots from 'assets/images/rules/conqueror/boots_of_the_vanguard.jpg';
import ConquerorChest from 'assets/images/rules/conqueror/chestguard_of_the_vanguard.jpg';
import ConquerorGloves from 'assets/images/rules/conqueror/gauntlets_of_the_vanguard.jpg';
import ConquerorHelm from 'assets/images/rules/conqueror/helm_of_the_vanguard.jpg';
import ConquerorLegs from 'assets/images/rules/conqueror/legguards_of_the_vanguard.jpg';
import ConquerorWrists from 'assets/images/rules/conqueror/vambraces_of_the_vanguard.jpg';

import DarkTemplarShoulder from 'assets/images/rules/darktemplar/armguards_of_the_wicked.jpg';
import DarkTemplarBelt from 'assets/images/rules/darktemplar/belt_of_the_wicked.jpg';
import DarkTemplarBoots from 'assets/images/rules/darktemplar/boots_of_the_wicked.jpg';
import DarkTemplarChest from 'assets/images/rules/darktemplar/chestguard_of_the_wicked.jpg';
import DarkTemplarGloves from 'assets/images/rules/darktemplar/gauntlets_of_the_wicked.jpg';
import DarkTemplarHelm from 'assets/images/rules/darktemplar/helm_of_the_wicked.jpg';
import DarkTemplarLegs from 'assets/images/rules/darktemplar/legguards_of_the_wicked.jpg';
import DarkTemplarWrists from 'assets/images/rules/darktemplar/vambraces_of_the_wicked.jpg';

import PriestofMitraShoulder from 'assets/images/rules/priestofmitra/armbands_of_tribulation.jpg';
import PriestofMitraBelt from 'assets/images/rules/priestofmitra/belt_of_tribulation.jpg';
import PriestofMitraBoots from 'assets/images/rules/priestofmitra/boots_of_tribulation.jpg';
import PriestofMitraChest from 'assets/images/rules/priestofmitra/harness_of_tribulation.jpg';
import PriestofMitraGloves from 'assets/images/rules/priestofmitra/gloves_of_tribulation.jpg';
import PriestofMitraHelm from 'assets/images/rules/priestofmitra/helm_of_tribulation.jpg';
import PriestofMitraLegs from 'assets/images/rules/priestofmitra/tasset_of_tribulation.jpg';
import PriestofMitraWrists from 'assets/images/rules/priestofmitra/bracers_of_tribulation.jpg';

import TempestofSetShoulder from 'assets/images/rules/tempestofset/armbands_of_vengeful_zeal.jpg';
import TempestofSetBelt from 'assets/images/rules/tempestofset/belt_of_vengeful_zeal.jpg';
import TempestofSetBoots from 'assets/images/rules/tempestofset/boots_of_vengeful_zeal.jpg';
import TempestofSetChest from 'assets/images/rules/tempestofset/harness_of_vengeful_zeal.jpg';
import TempestofSetGloves from 'assets/images/rules/tempestofset/gloves_of_vengeful_zeal.jpg';
import TempestofSetHelm from 'assets/images/rules/tempestofset/helm_of_vengeful_zeal.jpg';
import TempestofSetLegs from 'assets/images/rules/tempestofset/tasset_of_vengeful_zeal.jpg';
import TempestofSetWrists from 'assets/images/rules/tempestofset/bracers_of_vengeful_zeal.jpg';

import BearShamanShoulder from 'assets/images/rules/bearshaman/armbands_of_ferine_anger.jpg';
import BearShamanBelt from 'assets/images/rules/bearshaman/belt_of_ferine_anger.jpg';
import BearShamanBoots from 'assets/images/rules/bearshaman/boots_of_ferine_anger.jpg';
import BearShamanChest from 'assets/images/rules/bearshaman/harness_of_ferine_anger.jpg';
import BearShamanGloves from 'assets/images/rules/bearshaman/gloves_of_ferine_anger.jpg';
import BearShamanHelm from 'assets/images/rules/bearshaman/helm_of_ferine_anger.jpg';
import BearShamanLegs from 'assets/images/rules/bearshaman/leggings_of_ferine_anger.jpg';
import BearShamanWrists from 'assets/images/rules/bearshaman/bracers_of_ferine_anger.jpg';

import BarbarianShoulder from 'assets/images/rules/barbarian/brassart_of_vicious_frenzy.jpg';
import BarbarianBelt from 'assets/images/rules/barbarian/belt_of_vicious_frenzy.jpg';
import BarbarianBoots from 'assets/images/rules/barbarian/boots_of_vicious_frenzy.jpg';
import BarbarianChest from 'assets/images/rules/barbarian/harness_of_vicious_frenzy.jpg';
import BarbarianGloves from 'assets/images/rules/barbarian/gloves_of_vicious_frenzy.jpg';
import BarbarianHelm from 'assets/images/rules/barbarian/helm_of_vicious_frenzy.jpg';
import BarbarianLegs from 'assets/images/rules/barbarian/leggings_of_vicious_frenzy.jpg';
import BarbarianWrists from 'assets/images/rules/barbarian/bracers_of_vicious_frenzy.jpg';

import AssassinShoulder from 'assets/images/rules/assassin/armbands_of_the_whispering_blade.jpg';
import AssassinBelt from 'assets/images/rules/assassin/belt_of_the_whispering_blade.jpg';
import AssassinBoots from 'assets/images/rules/assassin/boots_of_the_whispering_blade.jpg';
import AssassinChest from 'assets/images/rules/assassin/bindings_of_the_whispering_blade.jpg';
import AssassinGloves from 'assets/images/rules/assassin/gloves_of_the_whispering_blade.jpg';
import AssassinHelm from 'assets/images/rules/assassin/hood_of_the_whispering_blade.jpg';
import AssassinLegs from 'assets/images/rules/assassin/shendoh_of_the_whispering_blade.jpg';
import AssassinWrists from 'assets/images/rules/assassin/wristbands_of_the_whispering_blade.jpg';

import RangerShoulder from 'assets/images/rules/ranger/armbands_of_the_farseeker.jpg';
import RangerBelt from 'assets/images/rules/ranger/belt_of_the_farseeker.jpg';
import RangerBoots from 'assets/images/rules/ranger/boots_of_the_farseeker.jpg';
import RangerChest from 'assets/images/rules/ranger/hauberk_of_the_farseeker.jpg';
import RangerGloves from 'assets/images/rules/ranger/gloves_of_the_farseeker.jpg';
import RangerHelm from 'assets/images/rules/ranger/helm_of_the_farseeker.jpg';
import RangerLegs from 'assets/images/rules/ranger/leggings_of_the_farseeker.jpg';
import RangerWrists from 'assets/images/rules/ranger/bracers_of_the_farseeker.jpg';

import DemonologistShoulder from 'assets/images/rules/demonologist/armwraps_of_fiendish_invocation.jpg';
import DemonologistBelt from 'assets/images/rules/demonologist/belt_of_fiendish_invocation.jpg';
import DemonologistBoots from 'assets/images/rules/demonologist/boots_of_fiendish_invocation.jpg';
import DemonologistChest from 'assets/images/rules/demonologist/robe_of_fiendish_invocation.jpg';
import DemonologistGloves from 'assets/images/rules/demonologist/gloves_of_fiendish_invocation.jpg';
import DemonologistHelm from 'assets/images/rules/demonologist/hood_of_fiendish_invocation.jpg';
import DemonologistLegs from 'assets/images/rules/demonologist/leggings_of_fiendish_invocation.jpg';
import DemonologistWrists from 'assets/images/rules/demonologist/wristwraps_of_fiendish_invocation.jpg';

import HeraldofXotliShoulder from 'assets/images/rules/heraldofxotli/armwraps_of_the_doomsayer.jpg';
import HeraldofXotliBelt from 'assets/images/rules/heraldofxotli/belt_of_the_doomsayer.jpg';
import HeraldofXotliBoots from 'assets/images/rules/heraldofxotli/boots_of_the_doomsayer.jpg';
import HeraldofXotliChest from 'assets/images/rules/heraldofxotli/tunic_of_the_doomsayer.jpg';
import HeraldofXotliGloves from 'assets/images/rules/heraldofxotli/gloves_of_the_doomsayer.jpg';
import HeraldofXotliHelm from 'assets/images/rules/heraldofxotli/hood_of_the_doomsayer.jpg';
import HeraldofXotliLegs from 'assets/images/rules/heraldofxotli/tasset_of_the_doomsayer.jpg';
import HeraldofXotliWrists from 'assets/images/rules/heraldofxotli/wristwraps_of_the_doomsayer.jpg';

import NecromancerShoulder from 'assets/images/rules/necromancer/armwraps_of_the_forsaken.jpg';
import NecromancerBelt from 'assets/images/rules/necromancer/belt_of_the_forsaken.jpg';
import NecromancerBoots from 'assets/images/rules/necromancer/footwraps_of_the_forsaken.jpg';
import NecromancerChest from 'assets/images/rules/necromancer/bindings_of_the_forsaken.jpg';
import NecromancerGloves from 'assets/images/rules/necromancer/gloves_of_the_forsaken.jpg';
import NecromancerHelm from 'assets/images/rules/necromancer/helm_of_the_forsaken.jpg';
import NecromancerLegs from 'assets/images/rules/necromancer/loincloth_of_the_forsaken.jpg';
import NecromancerWrists from 'assets/images/rules/necromancer/wristwraps_of_the_forsaken.jpg';

//weapons
import Arrows from 'assets/images/rules/weapons/skirmishers_arrows.jpg';
import Blade from 'assets/images/rules/weapons/skirmishers_blade.jpg';
import Bolts from 'assets/images/rules/weapons/skirmishers_bolts.jpg';
import Crossbow from 'assets/images/rules/weapons/skirmishers_crossbow.jpg';
import Dirk from 'assets/images/rules/weapons/skirmishers_dirk.jpg';
import Greatbow from 'assets/images/rules/weapons/skirmishers_greatbow.jpg';
import Greatsword from 'assets/images/rules/weapons/skirmishers_greatsword.jpg';
import Krys from 'assets/images/rules/weapons/skirmishers_krys.jpg';
import MarkofAbhorrence from 'assets/images/rules/weapons/skirmishers_mark_of_abhorrence.jpg';
import MaximofEntropy from 'assets/images/rules/weapons/skirmishers_maxim_of_entropy.jpg';
import Sanctum from 'assets/images/rules/weapons/skirmishers_sanctum.jpg';
import Scepter from 'assets/images/rules/weapons/skirmishers_scepter.jpg';
import SpellGlaive from 'assets/images/rules/weapons/skirmishers_spell_glaive.jpg';
import SpellSword from 'assets/images/rules/weapons/skirmishers_spellsword.jpg';
import Staff from 'assets/images/rules/weapons/skirmishers_staff.jpg';
import Warfirst from 'assets/images/rules/weapons/skirmishers_war_fist.jpg';
import WarGlaive from 'assets/images/rules/weapons/skirmishers_war_glaive.jpg';
import WarMaul from 'assets/images/rules/weapons/skirmishers_war_maul.jpg';

//accessories
import BandofForce from 'assets/images/rules/accessories/band_of_force.jpg';
import BandofPower from 'assets/images/rules/accessories/band_of_power.jpg';
import Cloak from 'assets/images/rules/accessories/cloak_of_the_battle_hardened.jpg';
import Pendant from 'assets/images/rules/accessories/pendant_of_shielding.jpg';

import { classImages } from 'utilities/ClassImages';
import { AocClasses } from '@pvplevelup/core/dist/interfaces/ICharacter';
import { ButtonBase } from '@material-ui/core';
import { Visibility, Translate, Security as ShieldIcon, LocalDrink, Restaurant, Block, ChevronRight } from '@material-ui/icons';

// note: Electron 8 (Chromium 80) has no flexbox gap; spacing here is grid gap or margins

const ARMOR: Record<string, string[]> = {
  [AocClasses.Guardian]: [GuardianHelm, GuardianChest, GuardianLegs, GuardianGloves, GuardianBelt, GuardianBoots, GuardianShoulder, GuardianWrists],
  [AocClasses.DarkTemplar]: [DarkTemplarHelm, DarkTemplarChest, DarkTemplarLegs, DarkTemplarGloves, DarkTemplarBelt, DarkTemplarBoots, DarkTemplarShoulder, DarkTemplarWrists],
  [AocClasses.Conqueror]: [ConquerorHelm, ConquerorChest, ConquerorLegs, ConquerorGloves, ConquerorBelt, ConquerorBoots, ConquerorShoulder, ConquerorWrists],
  [AocClasses.PriestofMitra]: [PriestofMitraHelm, PriestofMitraChest, PriestofMitraLegs, PriestofMitraGloves, PriestofMitraBelt, PriestofMitraBoots, PriestofMitraShoulder, PriestofMitraWrists],
  [AocClasses.TempestofSet]: [TempestofSetHelm, TempestofSetChest, TempestofSetLegs, TempestofSetGloves, TempestofSetBelt, TempestofSetBoots, TempestofSetShoulder, TempestofSetWrists],
  [AocClasses.BearShaman]: [BearShamanHelm, BearShamanChest, BearShamanLegs, BearShamanGloves, BearShamanBelt, BearShamanBoots, BearShamanShoulder, BearShamanWrists],
  [AocClasses.Barbarian]: [BarbarianHelm, BarbarianChest, BarbarianLegs, BarbarianGloves, BarbarianBelt, BarbarianBoots, BarbarianShoulder, BarbarianWrists],
  [AocClasses.Assassin]: [AssassinHelm, AssassinChest, AssassinLegs, AssassinGloves, AssassinBelt, AssassinBoots, AssassinShoulder, AssassinWrists],
  [AocClasses.Ranger]: [RangerHelm, RangerChest, RangerLegs, RangerGloves, RangerBelt, RangerBoots, RangerShoulder, RangerWrists],
  [AocClasses.Demonologist]: [DemonologistHelm, DemonologistChest, DemonologistLegs, DemonologistGloves, DemonologistBelt, DemonologistBoots, DemonologistShoulder, DemonologistWrists],
  [AocClasses.HeraldofXotli]: [HeraldofXotliHelm, HeraldofXotliChest, HeraldofXotliLegs, HeraldofXotliGloves, HeraldofXotliBelt, HeraldofXotliBoots, HeraldofXotliShoulder, HeraldofXotliWrists],
  [AocClasses.Necromancer]: [NecromancerHelm, NecromancerChest, NecromancerLegs, NecromancerGloves, NecromancerBelt, NecromancerBoots, NecromancerShoulder, NecromancerWrists],
};
const ARMOR_SLOTS = ['Helm', 'Chest', 'Legs', 'Gloves', 'Belt', 'Boots', 'Shoulders', 'Wrists'];

const ARCHETYPES = [
  {label: 'Soldiers', classes: [AocClasses.Guardian, AocClasses.DarkTemplar, AocClasses.Conqueror]},
  {label: 'Priests', classes: [AocClasses.PriestofMitra, AocClasses.TempestofSet, AocClasses.BearShaman]},
  {label: 'Rogues', classes: [AocClasses.Barbarian, AocClasses.Assassin, AocClasses.Ranger]},
  {label: 'Mages', classes: [AocClasses.Demonologist, AocClasses.HeraldofXotli, AocClasses.Necromancer]},
];

const CATEGORIES = [
  {key: 'potions', label: 'Potions', images: [Daggamalt, SweetPressedHaste, Moonspill, PurifiedDaggamalt, PurifiedSweetPressedHaste, PurifiedMoonspill],
    note: 'Daggamalt, Sweetpressed Haste and Moonspill, or their purified guild versions.'},
  {key: 'consumables', label: 'Consumables', images: [LegofFena, RedDeviledDates, CynosuralOil],
    note: 'Leg of Fena, Red Deviled Dates and Cynosural Oil only.'},
  {key: 'weapons', label: 'Weapons', images: [Arrows, Greatbow, Crossbow, Bolts, Blade, Warfirst, Sanctum, WarGlaive, WarMaul, Dirk, Krys, Scepter, Greatsword, Staff, SpellGlaive, SpellSword, MarkofAbhorrence, MaximofEntropy],
    note: "PvP tier 1 Skirmisher's weapons. Use the ones your class can equip."},
  {key: 'accessories', label: 'Accessories', images: [BandofForce, BandofPower, Cloak, Pendant],
    note: 'Band of Force, Band of Power, Cloak of the Battle Hardened and Pendant of Shielding.'},
  {key: 'armor', label: 'Class armor', images: [] as string[], note: 'Your class\'s PvP tier 1 armor set. Pick a class to see it.'},
];

const RULES = [
  {icon: <Visibility />, title: 'Keep your equipment visible',
    text: 'Everyone in PvP must show their equipment to other players.',
    steps: ['Interface options', 'Basic', 'Uncheck "Hide my equipment from other players"']},
  {icon: <Translate />, title: 'Use the English client',
    text: 'The app reads the combat log, and only the English combat log is supported.'},
  {icon: <ShieldIcon />, title: 'PvP tier 1 only',
    text: 'Weapons, armor and accessories must be PvP tier 1, or blue items if you don\'t have the set yet. This keeps matches balanced and easy to get into.'},
  {icon: <LocalDrink />, title: 'Allowed potions',
    text: 'Daggamalt, Sweetpressed Haste, Moonspill, or their purified guild versions.',
    hint: 'Purified potions aren\'t recommended: you may be matched against a guild member and have to drop guild for the game.'},
  {icon: <Restaurant />, title: 'Allowed consumables',
    text: 'Leg of Fena, Red Deviled Dates and Cynosural Oil. No other consumables.'},
  {icon: <Block />, title: 'Nothing else',
    text: 'No runes, lodestones, Khitai blessings and so on.',
    hint: 'If it isn\'t explicitly allowed above, it isn\'t allowed.'},
];

const useStyles = makeStyles((theme) => {
	return {
    page: {
      maxWidth: 1100,
    },
    hero: {
      marginBottom: theme.spacing(3),
      padding: theme.spacing(3),
      borderRadius: 12,
      background: 'radial-gradient(circle at 0% 0%, rgba(66, 165, 245, 0.2), transparent 55%), rgba(20, 20, 20, 0.92)',
      border: '1px solid rgba(255, 255, 255, 0.1)',
    },
    kicker: {
      fontSize: '0.72rem',
      fontWeight: 700,
      letterSpacing: '0.12em',
      textTransform: 'uppercase',
      opacity: 0.6,
    },
    title: {
      fontSize: '2rem',
      fontWeight: 800,
      lineHeight: 1.2,
    },
    subtitle: {
      marginTop: 4,
      maxWidth: 720,
      fontSize: '0.95rem',
      lineHeight: 1.5,
      color: 'rgba(255, 255, 255, 0.65)',
    },
    rules: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
      gridGap: theme.spacing(2),
      marginBottom: theme.spacing(4),
    },
    rule: {
      display: 'grid',
      gridTemplateColumns: '44px minmax(0, 1fr)',
      gridGap: theme.spacing(1.75),
      alignItems: 'start',
      padding: theme.spacing(2),
      borderRadius: 10,
      background: 'rgba(20, 20, 20, 0.92)',
      border: '1px solid rgba(255, 255, 255, 0.09)',
    },
    ruleIcon: {
      position: 'relative',
      width: 44,
      height: 44,
      borderRadius: 11,
      display: 'grid',
      placeItems: 'center',
      color: '#42a5f5',
      background: 'rgba(66, 165, 245, 0.12)',
      border: '1px solid rgba(66, 165, 245, 0.28)',
    },
    ruleNumber: {
      position: 'absolute',
      top: -7,
      right: -7,
      width: 20,
      height: 20,
      borderRadius: '50%',
      display: 'grid',
      placeItems: 'center',
      fontSize: '0.7rem',
      fontWeight: 800,
      color: '#fff',
      background: '#1e88e5',
      boxShadow: '0 0 0 2px #141414',
    },
    ruleTitle: {
      fontSize: '1.02rem',
      fontWeight: 800,
    },
    ruleText: {
      marginTop: 4,
      fontSize: '0.9rem',
      lineHeight: 1.5,
      color: 'rgba(255, 255, 255, 0.75)',
    },
    hint: {
      marginTop: theme.spacing(1),
      padding: theme.spacing(0.75, 1),
      borderRadius: 7,
      fontSize: '0.8rem',
      lineHeight: 1.45,
      color: '#ffe082',
      background: 'rgba(255, 202, 40, 0.08)',
      border: '1px solid rgba(255, 202, 40, 0.25)',
    },
    steps: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      marginTop: theme.spacing(1),
    },
    step: {
      margin: '0 4px 4px 0',
      padding: '2px 8px',
      borderRadius: 6,
      fontSize: '0.78rem',
      fontWeight: 600,
      background: 'rgba(255, 255, 255, 0.07)',
      border: '1px solid rgba(255, 255, 255, 0.1)',
    },
    stepArrow: {
      margin: '0 4px 4px 0',
      fontSize: 16,
      opacity: 0.5,
    },
    sectionTitle: {
      marginBottom: theme.spacing(1.5),
      fontSize: '1.3rem',
      fontWeight: 800,
    },
    equipment: {
      borderRadius: 12,
      overflow: 'hidden',
      background: 'rgba(20, 20, 20, 0.92)',
      border: '1px solid rgba(255, 255, 255, 0.1)',
    },
    categories: {
      display: 'flex',
      flexWrap: 'wrap',
      padding: theme.spacing(1.5, 1.5, 0.75),
      borderBottom: '1px solid rgba(255, 255, 255, 0.07)',
    },
    category: {
      margin: theme.spacing(0, 0.75, 0.75, 0),
      padding: theme.spacing(0.75, 1.75),
      borderRadius: 8,
      fontSize: '0.88rem',
      fontWeight: 700,
      color: 'rgba(255, 255, 255, 0.7)',
      background: 'rgba(255, 255, 255, 0.04)',
      border: '1px solid rgba(255, 255, 255, 0.08)',
      transition: 'background 0.12s, color 0.12s, border-color 0.12s',
      '&:hover': {
        color: '#fff',
        background: 'rgba(255, 255, 255, 0.08)',
      },
    },
    categoryActive: {
      color: '#fff',
      background: 'rgba(66, 165, 245, 0.16)',
      borderColor: 'rgba(66, 165, 245, 0.6)',
    },
    equipmentBody: {
      padding: theme.spacing(2),
    },
    note: {
      marginBottom: theme.spacing(2),
      fontSize: '0.9rem',
      color: 'rgba(255, 255, 255, 0.65)',
    },
    gallery: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(190px, 1fr))',
      gridGap: theme.spacing(1.5),
      alignItems: 'start',
    },
    item: {
      padding: theme.spacing(1),
      borderRadius: 8,
      background: 'rgba(0, 0, 0, 0.35)',
      border: '1px solid rgba(255, 255, 255, 0.07)',
      '& img': {
        display: 'block',
        maxWidth: '100%',
        margin: '0 auto',
        borderRadius: 4,
      },
    },
    slot: {
      marginBottom: 6,
      fontSize: '0.68rem',
      fontWeight: 700,
      letterSpacing: '0.1em',
      textTransform: 'uppercase',
      opacity: 0.55,
    },
    archetypes: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
      gridGap: theme.spacing(1.5),
      marginBottom: theme.spacing(2.5),
    },
    archetypeLabel: {
      marginBottom: 6,
      fontSize: '0.68rem',
      fontWeight: 800,
      letterSpacing: '0.12em',
      textTransform: 'uppercase',
      color: '#90caf9',
    },
    classButton: {
      display: 'grid',
      gridTemplateColumns: '28px minmax(0, 1fr)',
      gridGap: theme.spacing(1),
      alignItems: 'center',
      justifyContent: 'stretch',
      width: '100%',
      marginBottom: 4,
      padding: theme.spacing(0.5, 1),
      borderRadius: 8,
      textAlign: 'left',
      fontSize: '0.88rem',
      fontWeight: 600,
      border: '1px solid transparent',
      transition: 'background 0.12s, border-color 0.12s',
      '&:hover': {
        background: 'rgba(255, 255, 255, 0.06)',
      },
      '& img': {
        width: 28,
        height: 28,
        display: 'block',
      },
    },
    classActive: {
      background: 'rgba(66, 165, 245, 0.14)',
      borderColor: 'rgba(66, 165, 245, 0.5)',
    },
	};
});

interface Props {}

/** The ranked matchmaking rules, and a browser of the gear, potions and consumables they allow. */
export const MatchmakingRules: React.FC<Props> = (props) => {
  const classes = useStyles();
  const [category, setCategory] = useState('potions');
  const [armorClass, setArmorClass] = useState<string>(AocClasses.Guardian);
  const active = CATEGORIES.find((c) => c.key == category) || CATEGORIES[0];

	return (
    <div className={`content-container ${classes.page}`}>
      <div className={classes.hero}>
        <div className={classes.kicker}>Ranked matchmaking</div>
        <div className={classes.title}>Rules</div>
        <div className={classes.subtitle}>
          Everyone plays by the same rules so matches stay fair and the app can track them. Below the rules you can browse the gear, potions and consumables you're allowed to use.
        </div>
      </div>

      <div className={classes.rules}>
        {RULES.map((rule, index) => (
          <div key={rule.title} className={classes.rule}>
            <div className={classes.ruleIcon}>
              {rule.icon}
              <span className={classes.ruleNumber}>{index + 1}</span>
            </div>
            <div style={{minWidth: 0}}>
              <div className={classes.ruleTitle}>{rule.title}</div>
              <div className={classes.ruleText}>{rule.text}</div>
              {rule.steps &&
                <div className={classes.steps}>
                  {rule.steps.map((step, i) => (
                    <React.Fragment key={step}>
                      {i > 0 && <ChevronRight className={classes.stepArrow} />}
                      <span className={classes.step}>{step}</span>
                    </React.Fragment>
                  ))}
                </div>
              }
              {rule.hint && <div className={classes.hint}>{rule.hint}</div>}
            </div>
          </div>
        ))}
      </div>

      <div className={classes.sectionTitle}>Allowed equipment</div>
      <div className={classes.equipment}>
        <div className={classes.categories}>
          {CATEGORIES.map((c) => (
            <ButtonBase key={c.key} className={`${classes.category} ${category == c.key ? classes.categoryActive : ''}`} onClick={() => setCategory(c.key)}>
              {c.label}
            </ButtonBase>
          ))}
        </div>
        <div className={classes.equipmentBody}>
          <div className={classes.note}>{active.note}</div>
          {category == 'armor' ?
            <React.Fragment>
              <div className={classes.archetypes}>
                {ARCHETYPES.map((archetype) => (
                  <div key={archetype.label}>
                    <div className={classes.archetypeLabel}>{archetype.label}</div>
                    {archetype.classes.map((aocClass) => (
                      <ButtonBase key={aocClass} className={`${classes.classButton} ${armorClass == aocClass ? classes.classActive : ''}`} onClick={() => setArmorClass(aocClass)}>
                        <img src={classImages.getColorIcon(aocClass)} alt={aocClass} />
                        <span>{aocClass}</span>
                      </ButtonBase>
                    ))}
                  </div>
                ))}
              </div>
              <div className={classes.gallery}>
                {(ARMOR[armorClass] || []).map((image, index) => (
                  <div key={image} className={classes.item}>
                    <div className={classes.slot}>{ARMOR_SLOTS[index]}</div>
                    <img src={image} alt={`${armorClass} ${ARMOR_SLOTS[index]}`} />
                  </div>
                ))}
              </div>
            </React.Fragment>
          :
            <div className={classes.gallery}>
              {active.images.map((image) => (
                <div key={image} className={classes.item}>
                  <img src={image} />
                </div>
              ))}
            </div>
          }
        </div>
      </div>
    </div>
	);
};
